import React, { createContext, useState, useCallback, useContext, } from 'react';
import styled from 'styled-components';
import { BannerItem } from './BannerItem';
export const BannerContext = createContext({
    addBanner: () => {
        throw new Error('Please add the BannerContainer to your application');
    },
});
export const useBannerContext = () => useContext(BannerContext);
export const BannerContainer = ({ children }) => {
    let bannerId = 0;
    const [banner, setBanner] = useState([]);
    // create banner unique ID
    const newBannerId = useCallback(() => {
        const newId = `MM_BANNER_${bannerId}`;
        bannerId++;
        return newId;
    }, [bannerId]);
    const addBanner = (banner) => {
        const newBanner = {
            ...banner,
            id: newBannerId(),
        };
        setBanner([newBanner]);
    };
    const deleteBanner = (id) => {
        setBanner(banner.filter((banner) => banner.id !== id));
    };
    return (React.createElement(BannerContext.Provider, { value: {
            addBanner,
        } },
        children,
        React.createElement(BannerWrapper, null, banner.map((banner) => (React.createElement(BannerItem, { key: banner.id, ...banner, deleteBanner: deleteBanner }))))));
};
const BannerWrapper = styled.div `
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 99;
`;
//# sourceMappingURL=BannerContainer.js.map